import { render, staticRenderFns } from "./MdmLink.vue?vue&type=template&id=04f75eb1&name=mdm-link&"
import script from "./MdmLink.vue?vue&type=script&lang=js&"
export * from "./MdmLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports